import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetCountry } from '@/shared/actions/erp/countries.actions';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveCountry } from '../../shared/components';

export type UpdateeCountryPageProps = {};

const returnUrlCountries = ROUTER_PATHS.administration.paisesNav;

const UpdateeCountryPage: React.FC<UpdateeCountryPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_pais);

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetCountry(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id_pais) return <Navigate to={returnUrlCountries} />;

  return <SaveCountry titlePage="Editar País" editCountry={data.data} />;
};

export default UpdateeCountryPage;
